import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDDOC_EVAL_VAL;

export default {
  update(payload) {
    return baseApi.put(resource, payload);
  },
};
